import React from "react";
import { NavLink } from "react-router-dom";
import "./styles/Specialization.scss";

var bnr1 = require("./../../images/background/bg-5.png");

class Specialization extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1"
          style={{ backgroundImage: "url(" + bnr1 + ")" }}
        >
          <div className="container">
            {/* IMAGE CAROUSEL START */}
            <div className="section-content">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6 m-b30">
                  <div className="image-effect-one hover-shadow custom-card">
                    <img src={require("../../images/home/4.png")} alt="" />
                    <div className="figcaption">
                      <h4>E-Commerce Supplies</h4>
                      <p>Fast access to essential products and materials.</p>
                      <NavLink to="/about">
                        <i className="link-plus bg-primary" />
                      </NavLink>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6 m-b30">
                  <div className="image-effect-one hover-shadow custom-card">
                    <img src={require("../../images/home/5.png")} alt="" />
                    <div className="figcaption">
                      <h4>Labour Services</h4>
                      <p>
                        Hire skilled and unskilled workers quickly and easily.
                      </p>
                      <NavLink to="/about">
                        <i className="link-plus bg-primary" />
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 m-b30">
                  <div className="image-effect-one hover-shadow custom-card">
                    <img
                      src={require("../../images/home/6.png")}
                      alt="Apartment Services"
                    />
                    <div className="figcaption bg-dark">
                      <h4>Apartment Services</h4>
                      <p>
                        Reliable plumbing, electrical, and maintenance services
                        for apartments.
                      </p>
                      <NavLink to="/services">
                        <i className="link-plus bg-primary" />
                      </NavLink>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mt-box our-speciallization-content">
                    <h3 className="m-t0">
                      <span className="font-weight-100">Your One-Stop</span>{" "}
                      <br />
                      Platform for Essential Services.
                    </h3>
                    <p>
                      JIT brings together e-commerce supplies, labour hiring,
                      and apartment rentals in one convenient place. Get
                      reliable services delivered right on time, without hassle
                      or delay.
                    </p>

                    <NavLink to="/about" className="site-button btn-effect">
                      Explore Services
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Specialization;
